// @ts-nocheck
import React, { useMemo, useState } from 'react';
import LocalizationContext from '../contexts/LocalizationContext';
import { LocalizationEntity } from '../models/localization';
import LocalizationHelper from '../../helpers/TranslationHelper';

interface Props {
  children: React.ReactNode;
  translationNodeKey: string;
}

const Localization: React.FC<Props> = ({ children, translationNodeKey }): JSX.Element => {
  const [localization, setLocalization] = useState<LocalizationEntity[]>([]);
  const [loading, setLoading] = useState(true);

  useMemo(async () => {
    try {
      const result = await LocalizationHelper.getTranslationForNode(translationNodeKey);
      setLocalization(result);
    } catch (error) {
      setLocalization([]);
    }
    setLoading(false);
  }, []);

  if (loading) {
    return null;
  }

  return (
    <LocalizationContext.Provider value={localization}>{children}</LocalizationContext.Provider>
  );
};

export default Localization;
